module.exports = __webpack_public_path__ + "media/images/icon-nav-logout-cbcd7e2fc946bb61a9945bda7e677a97.png";